module.exports = __webpack_public_path__ + "img/fontello.6848d625.svg";